const initialState = {
  vtkPngData: null,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'VTK_PNG_MANUAL_SUCCESS':
      return {
        ...state,
        vtkPngData: action.payload,
        error: null,
      };
    case 'VTK_PNG_MANUAL_ERROR':
      return {
        ...state,
        vtkPngData: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;